<template>
  <div class="login-box">
    <van-nav-bar title="登录" left-arrow @click-left="$router.push('/')" />
    <div class="login-container">
      <router-link to="/" class="logo">
        <img src="@/assets/images/logo.png"/>
      </router-link>
      <van-cell-group>
        <van-field value="请输入手机号" label="手机号:" v-model="phone" />
        <van-field
          value="请输入密码"
          label="密码:"
          type="password"
          v-model="password"
        />
      </van-cell-group>
     <div style="height:30px;"></div>
      <van-button type="danger" size="large" @click="doLogin">登录</van-button>
      <div class="tips">
        <router-link to="/reg">没有账号，前往注册</router-link>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      phone: "",
      password: "",
    };
  },
  methods: {
    doLogin() {
      this.Post(
        {
          username: this.phone,
          password: this.password,
        },
        "/main/login",
        (res) => {
          if (res.states == 1) {
            this.getConig();
            this.Toast.success("登录成功");
            const redirect = this.$route.query.redirect || false;
            if(redirect){
this.$router.replace(redirect);
            }else{
              this.$router.replace("/user");
            }
          } else {
            this.Toast.fail(res.msg);
          }
        }
      );
    },
    // 获取配置
    getConig() {
      this.Post({}, "/main/config", (res) => {
        if (res.states == 1) {
          this.setCookie("deposit", res.data.deposit, 0.1);
          this.setCookie("rate", res.data.rate, 0.1);
          this.setCookie("agent", res.data.agent, 0.1);
          this.$store.dispatch("setConfig", res.data);
        }
      });
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.login-box {
  .login-container{
    padding: 10px;
    .logo{
      display: block;
      padding: 60px 0;
      text-align: center;
      img{
        border-radius: 8px;
        height: 120px;
      }
    }
  }
  .tips {
    padding: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/account/login.vue